import React, { useState } from 'react';
import { logout } from "../../../Slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { VscSignOut } from "react-icons/vsc";
import ConfirmationModal from "../../common/ConfirmationModal";


const Sidebar = ({ onTabChange }) => {
  const { loading: authLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(null);
  return (
    
       <div className="bg-blue-800 text-white w-[20%] h-screen p-5 ml-10">
      <h2 className="text-2xl font-bold mb-10">Dashboard</h2>
      <ul className="space-y-6">
        <li onClick={() => onTabChange('profile')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          Profile
        </li>
        {/* hgvhgvhj */}
        <li onClick={() => onTabChange('create-category')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          Create Category
        </li>
        <li onClick={() => onTabChange('create-mehendi-form')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          Create Mehendi Form
        </li>
        <li onClick={() => onTabChange('all-clients')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          All Clients
        </li>
        <li onClick={() => onTabChange('create-galary')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          Create Gallary
        </li>
        <li onClick={() => onTabChange('settings')} className="cursor-pointer hover:bg-blue-700 p-2 rounded">
          Settings
        </li>
        
        <button
              onClick={() =>
                setConfirmationModal({
                  text1: "Are you sure?",
                  text2: "You will be logged out of your account.",
                  btn1Text: "Logout",
                  btn2Text: "Cancel",
                  btn1Handler: () => dispatch(logout(navigate)),
                  btn2Handler: () => setConfirmationModal(null),
                })
              }
              className="px-1 py-2 text-sm w-[14.3rem] rounded  text-white hover:bg-blue-700"
            >
              <div className="flex items-center gap-x-2 text-white">
                <VscSignOut className="text-lg" />
                <span>Logout</span>
              </div>
            </button>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    
      </ul>
    </div>

   
  );
};

export default Sidebar;
